export default __webpack_public_path__ + "static/media/sodium-hydroxide.841bc945.jpg";